import React from 'react';
import './ProgressTracker.css';
import { PROJECT_STATUS_VALUES } from '../../constants/CONSTANT';

const ProgressTracker = ({ currentStep }) => {
  return (
    <div className="progress-container">
      {currentStep === 11 && (
        <div className="sparkles">
          <div className="sparkle" style={{ top: "10px", left: "20px" }}></div>
          <div className="sparkle" style={{ top: "20px", left: "30px" }}></div>
          <div className="sparkle" style={{ top: "30px", left: "40px" }}></div>
          <div className="sparkle" style={{ top: "40px", left: "50px" }}></div>
        </div>
      )}
      {PROJECT_STATUS_VALUES.map((step, index) => (
        <div className="progress-step" key={index}>
          <div className={`progress-circle ${index === currentStep ? 'active' : index < currentStep ? 'completed' : ''}`}>
            <span className="step-number">
              {index < currentStep ? '✔' : index + 1}
            </span>
          </div>
          <div className="progress-label">
            {step.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgressTracker;
